<template>
  <section class="document-list">
    <header>
      <mo-pageheader>
        <template slot="title">{{ $t('title.documentList') }}</template>
      </mo-pageheader>
    </header>

    <main class="main-layout">
        <!-- TAB SECTION -->
        <div class="tabs-ctn flex flex-center">
          <div
            v-if="accessInfoGeneral"
            class="tab"
            :class="stateFicheArticle == 'general' ? 'active': ''"
            @click="stateFicheArticle = 'general'"
            >{{ $t('sectionTitle.informationG') }}
          </div>
          <div
            v-if="accessDuplication"
            class="tab"
            :class="stateFicheArticle == 'duplication' ? 'active': ''"
            @click="stateFicheArticle = 'duplication'"
            >{{ $t('sectionTitle.duplicationTitle') }}
          </div>
          <div
            v-if="accessStatistique"
            class="tab"
            :class="stateFicheArticle == 'statistique' ? 'active': ''"
            @click="stateFicheArticle = 'statistique'"
            >{{ $t('sectionTitle.statistique') }}
          </div>
          <div v-if="importCSV && accessImportCsv"
            class="tab"
            :class="stateFicheArticle == 'importcsv' ? 'active': ''"
            @click="stateFicheArticle = 'importcsv'"
            >{{ $t('sectionTitle.importcsv') }}
          </div>
         
        </div>
        
           <documentgeneral v-if="stateFicheArticle == 'general'"></documentgeneral>
           <documentduplication v-if="stateFicheArticle == 'duplication'"></documentduplication>
           <documentstatistique v-if="stateFicheArticle == 'statistique'"></documentstatistique>
           <documentimportcsv v-if="stateFicheArticle == 'importcsv'"></documentimportcsv>
   

    
</main>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import Paginate from 'vuejs-paginate';
import { AbIcon, BaButton, BaCard, BaDropdown, BaInput, BaSearch, BaSearchCard, BaSelect, BaStateLabel, BaTable } from '@ab/basic-components';
import MoLoader from '@/components/loader/mo-loader.vue';
import MoPageheader from '@/components/layout/nav/mo-pageheader.vue';
import MoSpeedometer from '@/components/tool/mo-speedometer.vue';

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import searchMixin from '@/components/mixins/search.js';
import sortableMixin from '@/components/mixins/sortable.js';

import documentgeneral from './DocumentList-general.vue';
import documentduplication from './DocumentList-duplication.vue';
import documentstatistique from './DocumentList-statistique.vue';
import documentimportcsv from './DocumentList-importcsv.vue';

export default {
  name: 'DocumentList',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaDropdown,
    BaInput,
    BaSearch,
    BaSearchCard,
    BaSelect,
    BaStateLabel,
    BaTable,
    MoLoader,
    MoPageheader,
    MoSpeedometer,
    Paginate,
    documentgeneral,
    documentduplication,
    documentstatistique,
    documentimportcsv
    
  },
  async mounted() {
  if(window.location.host == "localhost:8081" || window.location.host == "qa.ac-mb.pp.activbrowser.fr" ) {
      //  this.importCSV = true;
      }

   this.accessInfoGeneral = await this.$store.dispatch('getAccesRole', {search:10,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

   this.accessDuplication = await this.$store.dispatch('getAccesRole', {search:12,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole}); 

   this.accessStatistique = await this.$store.dispatch('getAccesRole', {search:14,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});

   this.accessImportCsv = await this.$store.dispatch('getAccesRole', {search:15,role:this.$store.state.authentication.user.Role.id,data:this.$store.state.authentication.user.allDetailRole});         
  },
  data() {
    return {
        stateFicheArticle:'general',
        importCSV:true,
        accessInfoGeneral: false,
        accessDuplication: false,
        accessStatistique: false,
        accessImportCsv: false,        
    };
  },
  computed: {
   
  },
  methods: {

  }
};
</script>


<style src="@/assets/styles/tabs.css"></style>
